import React from 'react'
import Recruit from './Container'
import List from '../json/recruitments'

import {timingFunctionExpand, timingFunctionCollapse} from '../animations'

export default class RecruitView extends React.PureComponent {

  constructor() {
    super()
    this.backToHome = this.backToHome.bind(this)
  }

  componentDidMount() {
    let header = document.querySelector('.recruit-header')
    let footer = document.querySelector('.l-footer.modal-footer')
    let bg = document.querySelector('section.recruitments_lower')
    let timeScale = 0.5

    let options  = {
      duration: 500 / timeScale,
      easing: timingFunctionExpand,
    }

    let flip = new window.FLIP.group([
      {...options, element: bg },
      {...options, element: footer, delay: 200/timeScale },
      {...options, element: header, delay: 500/timeScale  },
    ]);

    flip.first()
    flip.last('last')
    flip.invert()
    flip.play()
  }

  backToHome = () => {
    let header = document.querySelector('.recruit-header')
    let footer = document.querySelector('.l-footer.modal-footer')
    let bg = document.querySelector('section.recruitments_lower')
    let timeScale = 0.5

    let options  = {
      duration: 500 / timeScale,
      easing: timingFunctionCollapse,
    }

    let flip = new window.FLIP.group([
      {...options, element: bg},
      {...options, element: footer, delay: 200/timeScale },
      {...options, element: header, delay: 500/timeScale  },
    ]);

    flip.first()
    flip.removeClass('last')
    flip.last()
    flip.invert()
    flip.play()
    setTimeout(() => this.props.backToHome(), 400)
  }

  toFreshGraduate = () => {
    let el = document.querySelector('.group#new')
    el.scrollIntoView({ behavior: 'smooth',  block: 'start'  })
  }

  toMidCareer = () => {
    let el = document.querySelector('.group#mid')
    el.scrollIntoView({ behavior: 'smooth',  block: 'start'  })
  }

  render() {

    let data = List[this.props.data]
    let formUrl =  `https://www.lyzon.co.jp/recruit-form?${data.formParam}`

    return <Recruit
      style={this.props.style}
      backToHome={this.backToHome}
      data={data}
      formUrl={formUrl}
      toFreshGraduate={this.toFreshGraduate}
      toMidCareer={this.toMidCareer}
      />
  }
}


// WEBPACK FOOTER //
// ./src/Recruit/index.js